// Cabecera del espacio FONDO CRIPTO — identidad visual clara y distinta del
// trading personal (Njord), para que los dos espacios NO se confundan: marca
// "FONDO CRIPTO · Plutus", el subtítulo de la sección y la acción opcional.

import type { ReactElement, ReactNode } from 'react';

export function FondoHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}): ReactElement {
  return (
    <div className="mb-8">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-500 mb-2">
            <span aria-hidden>🪙</span>
            Fondo Cripto · Plutus
          </div>
          <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="text-ink-muted mt-2 max-w-xl">{subtitle}</p>}
        </div>
        {action}
      </div>
      <p className="mt-3 text-[11px] text-ink-subtle">
        Fondo común Maxi + Nelson · espacio separado de tu trading personal (Njord).
      </p>
    </div>
  );
}
